import { ImgHTMLAttributes } from "react"

import { DOMAIN_PREFIX } from "utils/env-management"

const IMAGES_PREFIX = `${DOMAIN_PREFIX}/images/`

type Props = ImgHTMLAttributes<HTMLImageElement>

export function Img({ src, alt, ...props }: Props) {
    return src ? <img alt={alt ?? ""} {...props} src={`${IMAGES_PREFIX}${src}`} /> : <></>
}
